import AsyncSelect from 'react-select/async';
import DeviceApi from 'api/device';
import { useState } from 'react';

const DeviceSelect = props => {
  const [value, setValue] = useState();

  const loadOptions = (input_value, callback) => {
    DeviceApi.fetch({ bot_id: props.botId }).then(data => {
      const options = data.map(item => {
        return {
          value: item.id,
          label: item.name,
          ...item,
        };
      });

      callback(options.filter(item => item.name.toLowerCase().includes(input_value.toLowerCase())));

      if (props.defaultValue) {
        const defaultValue = options.find(item => item.id === props.defaultValue);
        setValue(defaultValue || {});
      } else {
        if (options.length === 1) {
          setValue(options[0]);
        }
      }
    });
  };

  const handleChange = data => {
    setValue(data);
  };

  return (
    <>
      <AsyncSelect
        placeholder={props.placeholder || 'Device'}
        classNamePrefix="select"
        onChange={handleChange}
        cacheOptions
        defaultOptions
        loadOptions={loadOptions}
        value={value}
        {...props}
      />
      <input type="hidden" id="hidden_input_device_id" name="device_id" required={props.required} value={value ? value.id : null} />
    </>
  );
};
export default DeviceSelect;
